import { Navigate, useParams } from "react-router-dom";
import SignInForm from "../../components/Form/SignIn.form";
import LoginLayout from "../../layouts/login.layout";
import { loginSideBanner, userTypeTypeNameToKeyMap } from "../../utils/constant/login.constant";

const LoginPage = () => {
  const { type } = useParams<{ type: keyof typeof userTypeTypeNameToKeyMap }>();

  if (!type || !(type in userTypeTypeNameToKeyMap) || type !== "organization") {
    // redirect to home page
    return <Navigate to="/login" replace />;
  }

  const userTypeKey = userTypeTypeNameToKeyMap[type] as keyof typeof loginSideBanner;

  return (
    <LoginLayout sideBanner={loginSideBanner[userTypeKey]}>
      <div className=" flex flex-col items-center w-full md:max-w-[700px] bg-white">
        <div className="mt-2 md:mt-12 w-full md:w-[400px] pb-32  md:pb-0 ">
          <SignInForm signupType={userTypeKey} type={type} />
        </div>
      </div>
    </LoginLayout>
  );
};

export default LoginPage;
